<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed right-4 top-4 z-[100] flex w-[min(92vw,24rem)] flex-col gap-3">
      <transition-group name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto overflow-hidden rounded-2xl border shadow-[0_18px_45px_rgba(15,23,42,0.18)] backdrop-blur"
          :class="toastClasses(toast.type)"
        >
          <div class="flex items-start gap-3 px-4 py-3.5">
            <div class="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full" :class="dotClasses(toast.type)"></div>
            <div class="min-w-0 flex-1 text-sm font-medium leading-6">{{ toast.message }}</div>
            <button type="button" class="shrink-0 text-base leading-none text-stone-400 transition hover:text-stone-700" @click="removeToast(toast.id)">
              ×
            </button>
          </div>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<script setup>
import { useToast } from "../composables/useToast";

const { toasts, removeToast } = useToast();

const toastClasses = (type) => {
  if (type === "success") {
    return "border-emerald-200 bg-white/95 text-emerald-800";
  }

  if (type === "error") {
    return "border-amber-200 bg-white/95 text-amber-800";
  }

  return "border-stone-200 bg-white/95 text-stone-800";
};

const dotClasses = (type) => {
  if (type === "success") return "bg-emerald-500";
  if (type === "error") return "bg-amber-500";
  return "bg-brand-500";
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}
</style>
